<template>
  <v-row>
    <v-col cols="2"><v-icon style="font-size: 150px">fa-exclamation-circle</v-icon></v-col>
    <v-col cols="10"
      ><h1>{{ $t("global.404.title") }}</h1>
      {{ $t("global.404.content") }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "404View"
};
</script>

<style scoped></style>
